module.exports = __webpack_public_path__ + "static/assets/00d2dff9d5ece15a67074374b2027590.mp3";